var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.214,0v512h266.358l2.197-2.197l92.82-92.819l2.197-2.197V0H74.214z M344.966,486.393v-67.212h67.213L344.966,486.393 z M422.786,404.181h-92.82V497H89.214V15h333.572V404.181z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.21,
    y: 123.09,
    width: 15,
    height: 15.454
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.214,40 137.587,40 137.587,25 99.214,25 99.214,105.479 114.214,105.479  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.168,228.203l3.325,4.474c0.63,0.85,15.756,21.055,40.318,41.493c32.972,27.435,67.271,41.936,99.189,41.936 c31.918,0,66.217-14.501,99.189-41.936c24.563-20.439,39.689-40.643,40.32-41.493l3.325-4.474l-3.325-4.474 c-0.632-0.85-15.758-21.055-40.32-41.493c-32.147-26.749-65.553-41.196-96.786-41.903c-0.798-0.021-1.599-0.034-2.402-0.034 c-0.803,0-1.604,0.012-2.402,0.034c-31.233,0.707-64.64,15.154-96.786,41.903c-24.563,20.439-39.688,40.643-40.32,41.493 L113.168,228.203z M331.259,182.835c23.774,16.792,41.422,36.649,48.637,45.368c-7.217,8.723-24.875,28.59-48.662,45.385 c8.03-13.259,12.658-28.797,12.658-45.398C343.892,211.607,339.274,196.084,331.259,182.835z M256,155.299 c40.192,0,72.892,32.699,72.892,72.892c0,40.192-32.699,72.892-72.892,72.892s-72.892-32.699-72.892-72.892 S215.808,155.299,256,155.299z M180.741,182.835c-8.015,13.249-12.633,28.773-12.633,45.355c0,16.6,4.627,32.139,12.658,45.398 c-23.79-16.797-41.447-36.666-48.662-45.386C139.319,219.484,156.967,199.627,180.741,182.835z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,273.353c24.902,0,45.162-20.26,45.162-45.162c0-24.902-20.26-45.162-45.162-45.162s-45.162,20.26-45.162,45.162 C210.838,253.093,231.098,273.353,256,273.353z M256,198.029c16.632,0,30.162,13.531,30.162,30.162 c0,16.631-13.53,30.162-30.162,30.162s-30.162-13.531-30.162-30.162S239.368,198.029,256,198.029z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.32,
    y: 45.4,
    width: 118.07,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.32,
    y: 83.43,
    width: 118.07,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.28,
    y: 345.96,
    width: 140.77,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.28,
    y: 395.63,
    width: 113.53,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.28,
    y: 445.3,
    width: 113.53,
    height: 15
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.a0f53cdb5def9f6b6c5ec34785a1d1c6.svg";
export { ForwardRef as ReactComponent };